/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import { UTCISODateFromString } from "@pagopa/ts-commons/lib/dates";

// required attributes
const CounterpartTableR = t.interface({
  business_name: t.string,

  creditor_institution_code: t.string,

  id_counterpart_table: t.string,

  publication_date: UTCISODateFromString,

  validity_date: UTCISODateFromString
});

// optional attributes
const CounterpartTableO = t.partial({});

export const CounterpartTable = t.intersection(
  [CounterpartTableR, CounterpartTableO],
  "CounterpartTable"
);

export type CounterpartTable = t.TypeOf<typeof CounterpartTable>;
